import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { i18n } from '../../index'
import type { NightTask } from '../../station/stationTypes'
import NightTaskForm from './NightTaskForm'
type NightTaskDialogProps = {
  data: NightTask | null | undefined
  stationId: string
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}

class NightTaskDialog extends React.PureComponent<NightTaskDialogProps> {
  render() {
    const { data, stationId, isOpen, onClose } = this.props
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
      >
        <DialogTitle id='form-dialog-title'>
          {data && data.id
            ? i18n.t('admin.stations.title.nightTasksEditDialog')
            : i18n.t('admin.stations.title.nightTasksCreateDialog')}
        </DialogTitle>
        <DialogContent>
          <NightTaskForm data={data} stationId={stationId} onSubmit={onClose} onCancel={onClose} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default NightTaskDialog
